import { Backdrop, Box, Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Fade from '@mui/material/Fade';
import successImage from "../../Assets/success-back.svg"
import checkIcon from "../../Assets/checkIcon.svg"
import CloseIcon from '@mui/icons-material/Close';
import CustomInputField from '../Common/CustomInputField';
import { get, getDatabase, push, ref, set, update } from 'firebase/database';
import { app } from '../../Utils/Firebase';
import { Formik } from 'formik';
import { FolderNameValidation, RenameFileNameValidation } from '../../Utils/Validation';
import { Folder, Media } from '../../Utils/Constant';
import AlertModal from '../Common/AlertModal';
import { generateCustomId } from '../../Utils/utils';

const defaultValues = { name: "" };

function CreateFolderModal({ open, handleClose, currentFolderId, folderData, getFolderFiles }) {
    const [initialValues, setInitialValues] = useState(defaultValues);
    const [successOpen, setSuccessOpen] = useState(false);
    const db = getDatabase(app);
    const userId = localStorage.getItem("id");

    const handleUpdateChanges = async (values) => {
        try {
            const folderPayload = {
                name: values?.name,
                files: [],
                folders: [],
                user_id: userId
            }
            const newFolderId = generateCustomId();
            await set(ref(db, `${Folder}/${newFolderId}`), folderPayload);
            const folders = Array.isArray(folderData?.folders) ? folderData.folders : [];
            const currentFolderPayload = {
                ...folderData,
                folders: [...folders, { id: newFolderId, name: values?.name }]
            }
            await set(ref(db, `${Folder}/${currentFolderId}`), currentFolderPayload);
            handleClose();
            getFolderFiles();
            setSuccessOpen(true);
            setTimeout(() => {
                setSuccessOpen(false)
            }, 4000);
        } catch (error) {
            console.log(error);
        }
    }

    return (<>
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={FolderNameValidation}
                        onSubmit={handleUpdateChanges}
                        enableReinitialize
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            setFieldValue
                        }) => (
                            <>
                                <div style={{ position: 'absolute', zIndex: -1 }}><img src={successImage} height={"400px"} /></div>
                                <div style={{ position: 'absolute', zIndex: 1, right: "20px", top: "20px" }}><CloseIcon onClick={handleClose} /></div>
                                <div className='modal-container'>
                                    <p className='modal-title'>{"Create Folder"}</p>
                                    <CustomInputField label="Name" name="name" onChange={handleChange} error={touched?.name && errors.name} value={values?.name} style={{ width: "80%" }} />
                                    <button type='submit' onClick={handleSubmit} disabled={isSubmitting} className='btn12' style={{ padding: "22px 40px", width: "80%" }}>
                                        Create Folder
                                    </button>
                                </div>
                            </>
                        )}
                    </Formik >
                </Box>
            </Fade>
        </Modal>
        <AlertModal
            open={successOpen}
            handleClose={() => setSuccessOpen(false)}
            title={`Folder created`}
            desc={"Folder created successfully."}
            icon={checkIcon}
            success={true}
        />
    </>
    )
}

export default CreateFolderModal

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
        xs: "90%",
        sm: '650px',
    },
    height: '400px',
    backgroundColor: "rgba(240, 249, 254, 1)",
    borderRadius: "30px"
};